import { useEffect, useState } from 'react'

import AddIcon from '@material-ui/icons/Add'
import GetAppIcon from '@material-ui/icons/GetApp'
import SetState from 'Components/Hooks/SetState'
import NavBarGlobal from 'Components/UI/Molecules/NavBar'
import PaymentOrdersTable from 'Components/UI/Organisms/Sales/PaymentOrders'
import CreatePaymentOrder from 'Components/UI/Organisms/Sales/PaymentOrders/Create'
import ExportPaymentOrders from 'Components/UI/Organisms/Sales/PaymentOrders/Export'
import { oemColorButton } from 'Helpers'
import { useLocation } from 'react-router-dom'
import { getUbicacion } from 'service/helpers/localstorage'
import { interfaces } from 'service/interfaces'

import TemplateGlobal from '../../Common'

const PaymentOrdersTemplate = () => {
  const [render, setRender] = useState(true)
  const [dataBefore, setDataBefore] = useState()
  const { state: openExport, setOpen: setOpenExport, setClose: setCloseExport } = SetState()
  const { state: openNew, setOpen: setOpenNew, setClose: setCloseNew } = SetState()

  const location = getUbicacion() || ''
  const { pathname } = useLocation()

  const getCurrentEmpresa = () => {
    const normalized = String(location || '').toUpperCase()
    if (normalized.includes('OEM')) return 'OEM'
    if (normalized.includes('DOS')) return 'DOS'
    if (normalized.includes('ECO RIO CUARTO')) return 'ECO'
    return 'ECO'
  }

  async function apiCallBefore() {
    await interfaces.salesPaymentOrders.getBeforeData().then((res) => {
      setDataBefore({
        data: res.data,
      })
    })
  }

  useEffect(() => {
    apiCallBefore()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [render])

  const currentEmpresa = getCurrentEmpresa()
  const allPermissions = dataBefore?.data.permissions || {}
  const permissions = allPermissions[currentEmpresa] || {}

  const BUTTONS = [
    {
      onClick: setOpenExport,
      menuTitle: 'Exportar',
      menuIcon: <GetAppIcon fontSize="small" />,
      buttonContent: <GetAppIcon style={{ color: 'black' }} />,
      disabled: !permissions?.export,
    },
    {
      onClick: setOpenNew,
      menuTitle: 'Nuevo',
      menuIcon: <AddIcon fontSize="small" />,
      buttonContent: 'Nuevo',
      buttonStartIcon: <AddIcon />,
      buttonStyle: permissions?.create ? oemColorButton(pathname, location) : {},
      disabled: !permissions?.create,
    },
  ]

  return (
    <div>
      <TemplateGlobal
        navbar={<NavBarGlobal title="Ventas" subTitle="Ordenes de pago" buttons={BUTTONS} />}
        table={
          <PaymentOrdersTable
            render={render}
            setRender={setRender}
            permissions={permissions}
            dataBefore={dataBefore}
          />
        }
      />

      {openExport.suspense && (
        <ExportPaymentOrders open={openExport.open} onClose={setCloseExport} />
      )}

      {openNew.suspense && (
        <CreatePaymentOrder
          render={render}
          setRender={setRender}
          open={openNew.open}
          handleClose={setCloseNew}
        />
      )}
    </div>
  )
}

export default PaymentOrdersTemplate
